
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"fxa-permissions-header\">{{#t}}Request for permission{{/t}}</h1>\n  </header>\n\n  <section>\n    <div class=\"error\"></div>\n    <div class=\"success\"></div>\n\n    <p id=\"permission-request\">{{#t}}%(serviceName)s wants the following information from your account:{{/t}}</p>\n\n    <form id=\"permissions\" novalidate>\n      {{{ unsafePermissionsHTML }}}\n\n      <div class=\"button-row\">\n        <button id=\"accept\" type=\"submit\">{{#t}}Accept{{/t}}</button>\n      </div>\n    </form>\n\n    <ul class=\"links permission-links\">\n      <li><a href=\"#\" id=\"back\">{{#t}}Cancel{{/t}}</a></li>\n    </ul>\n\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/permissions.mustache
// module id = 266
// module chunks = app